import React from "react";
import './WhyChooseUs.css'
import { FaGift, FaMoneyBillWave, FaHeadset, FaBolt } from "react-icons/fa";

const WhyChooseUs = () => {
  const features = [
    { icon: <FaGift />, title: "Get a Bonus Up to 100%" },
    { icon: <FaMoneyBillWave />, title: "Zero Commission on All Trades" },
    { icon: <FaHeadset />, title: "Customer Support In Your Language" },
    { icon: <FaBolt />, title: "Instant Deposits & Quick Withdrawals" },
  ];

  return (
    <section className="why-choose">
      <div className="why-choose-overlay">
      <p className='section-highlight'>Account</p>
      <h1 className='section-heading'>Why Choose Us </h1>
      </div>
      <div className="why-choose-container">
        <div className="features-grid">
          {features.map((feature, index) => (
            <div className="feature-card" key={index}>
              <div className="icon">{feature.icon}</div>
              <h3 className="feature-title">{feature.title}</h3>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;
